export const jobDetails = () => {
    translateDurationLabel();
};

const translateDurationLabel = () => {
    const duration = document.querySelector(".attrax-job-information-widget__dynamic-field.durationinmonths");
    if (!duration) return;
    const durationLabel = duration.querySelector(".attrax-job-information-widget__dynamic-field-name");
    if (!durationLabel) return;

    durationLabel.textContent = "{{js.duration-label}}";
};